import React from 'react';

import SimpleMessagePage from 'components/SimpleMessagePage';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

import CancelButton from 'features/CancelButton';

const UnifiedApplicationError: React.FC = () => {
  const tMd = useMarkdownTranslate();
  return (
    <SimpleMessagePage
      headerTitle={'unified.application.error.title'}
      message={tMd('unified.application.error.message')}
    >
      <CancelButton />
    </SimpleMessagePage>
  );
};

export default UnifiedApplicationError;
